import React from 'react';

export interface Props {
  name: string;
  children?: React.ReactNode;
}

const Variant: React.FC<Props> = ({ children }) =>
  children && React.isValidElement(children) ? children : null;

export default Variant;
